import { render, staticRenderFns } from "./StatisticWidgetActionTime.vue?vue&type=template&id=570ee374&scoped=true&"
import script from "./StatisticWidgetActionTime.vue?vue&type=script&lang=js&"
export * from "./StatisticWidgetActionTime.vue?vue&type=script&lang=js&"
import style0 from "./StatisticWidgetActionTime.vue?vue&type=style&index=0&id=570ee374&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ee374",
  null
  
)

export default component.exports